/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, {
  useEffect, useReducer, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ProfileReducer, { initialState } from './reducer';
import ACTIONS_TYPE from './actionType';
import { getPartnerDetail, getPartnersFilters } from '../../../services/partner.service';
import { getFormattedProfileData, getPartnerTranslationData } from '../../../utils/profile.util';
import { pageViewEvent } from '../../analyticsApi';

export const ProfileContext = React.createContext(initialState);
const getInitialState = (store) => {
  const { errors = {} } = store || {};
  const { error = false } = errors;
  if (error) return initialState;
  return store;
};
export function ProfileContextProvider({ children, store }) {
  const { id } = useParams();
  const [state, dispatch] = useReducer(ProfileReducer, getInitialState(store));
  const scrollRef = useRef([]);
  // eslint-disable-next-line no-unused-vars
  const [translationsUpdated, setTranslationsUpdated] = useState(false);

  const getTranslatedPartnerDetail = async (profileDetails, partnerDetail) => {
    const textToTranslate = getPartnerTranslationData(profileDetails);
    if (partnerDetail?.body_overview) {
      textToTranslate.push({
        source: partnerDetail?.body_overview,
      });
    }
    if (partnerDetail?.headline) {
      textToTranslate.push({
        source: partnerDetail?.headline,
      });
    }
    dispatch({ type: ACTIONS_TYPE.SET_TRANSLATION_TEXT, payload: textToTranslate });
  };

  const fetechPartnerProfile = async () => {
    try {
      dispatch({ type: ACTIONS_TYPE.PROFILE_LOADING, payload: true });
      const response = await getPartnerDetail(id);
      const { data } = await getPartnersFilters();
      const profileDetails = await getFormattedProfileData({ filterData: data, profileData: response.data });
      getTranslatedPartnerDetail(profileDetails, response.data);
      dispatch({ type: ACTIONS_TYPE.SET_PARTNER_DETAILS, payload: response.data || {} });
      dispatch({ type: ACTIONS_TYPE.SET_PROFILE_DETAILS, payload: profileDetails || {} });
      dispatch({ type: ACTIONS_TYPE.PROFILE_LOADING, payload: false });
    } catch (e) {
      // console.error(e);
      dispatch({ type: ACTIONS_TYPE.PROFILE_LOADING, payload: false });
    }
  };

  useEffect(() => {
    const fetchAPi = async () => {
      pageViewEvent();
      const { errors, partnerDetails, profileDetails } = store || {};
      if (partnerDetails?.id) {
        getTranslatedPartnerDetail(profileDetails, partnerDetails);
      }
      if (!errors || errors?.error || (id && (!partnerDetails || partnerDetails?.id !== Number(id)))) {
        await fetechPartnerProfile();
      }
    };
    fetchAPi();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet key="helmet">
        <title>
          {store?.partnerDetails?.display_name || state?.partnerDetails?.display_name || 'Partner Profile'}
          {' '}
          | Autodesk Support
        </title>
      </Helmet>
      <ProfileContext.Provider
        value={{
          loading: state.loading,
          profileDetails: state.profileDetails,
          partnerDetails: state.partnerDetails,
          scrollRef,
          textToTranslate: state.textToTranslate,
        }}
      >
        {children}
      </ProfileContext.Provider>
    </>
  );
}
ProfileContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  store: PropTypes.shape({}),
};

ProfileContextProvider.defaultProps = {
  store: {},
};
export const ProfileContextConsumer = (Component) => (props) => (
  <ProfileContext.Consumer>
    {(context) => <Component {...props} {...context} />}
  </ProfileContext.Consumer>
);
